export default {"src":"/_next/static/media/icone-aura.73a5cb21.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};